export const MessagesError = {
    codigo_verificacion: 'Captcha incorrecto'
}

export const logErrors = ( e ) => {
    const errorModel = {
        Type: '',
        Message: ''
    }
console.log(e)
console.log(e.Message)
    if (e instanceof TypeError) {
        errorModel.Type = 'Type Error'
    } else if (e instanceof RangeError) {
        errorModel.Type = 'Range Error'
    } else if (e instanceof EvalError) {
        errorModel.Type = 'Eval Error'
    } else {
        errorModel.Type = 'Aviso'
    }

    if ( e.Message )
        errorModel.Message = e.Message
    else
        errorModel.Message = 'No se procesó su solicitud.<br>Disculpe la molestia.<br>Por favor, intentar en unos minutos.'

    return errorModel
}
